
import { useState, Fragment } from 'react';
import { Backdrop, CircularProgress, Box, Card, Typography, OutlinedInput, InputLabel, Stack, Button, Snackbar, InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import useAuth from '../hooks/useAuth';

import axios from "../api/axios"


export default function Login() {
    // Usar logindev en desarrollo local (sin encriptación)
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const LOGIN_URL = isLocalhost ? "login/logindev" : "login/login"
    const [usuario, setUsuario] = useState("")
    const [password, setPassword] = useState("")
    const [mensaje, setMensaje] = useState("")
    const [procesando, setProcesando] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const { setAuth } = useAuth();

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = (event) => event.preventDefault();

    const handleChange = (event) => {
        const nombre = event.target.name;
        const value = event.target.value;
        if (nombre === "usuario") { setUsuario(value) }
        if (nombre === "password") { setPassword(value) }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            clickLogin();
        }
    }

    const clickLogin = () => {
        if (usuario.length==0){setMensaje("Debe digitar su usuario"); return;}
        if (password.length==0){setMensaje("Debe digitar su contraseña"); return}
        login();
    }

    const handleCloseMensaje = ()=>{
        setMensaje("")
    }
    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const login = async ()=>{
        setProcesando(true)
        try {
            const response = await axios.post(LOGIN_URL, JSON.stringify({
                usuario: usuario,
                clave: password
            }), {
                headers: { 'Content-Type': 'application/json'},
                withCredentials: true
            });
            //console.log(JSON.stringify(response.data))
            if (response.data.respuesta==="S"){
                const usuario = response?.data.usuario;
                const accessToken = response?.data.accessToken;
                const inversionista = response.data.inversionista;
                const nivel = response.data.nivel;
                localStorage.setItem("accessToken", accessToken)
                localStorage.setItem("inversionista", inversionista)
                localStorage.setItem("nivel", nivel)

                setAuth({usuario: usuario, inversionista: inversionista, accessToken: accessToken, nivel: nivel})
            } else {
                setMensaje(response.data.mensaje)
            }
        } catch(error){
            setMensaje("Ha ocurrido un error, por favor intente más tarde")
        }
        setProcesando(false)
    }


    const actionMsg = (
        <Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleCloseMensaje}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Fragment>
      );

    return (
        <Box sx={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #0d1b2a 0%, #1b3a4b 50%, #2d4a5e 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Snackbar
                open={mensaje.length? true: false}
                autoHideDuration={6000}
                onClose={handleCloseMensaje}
                action={actionMsg}
                message={mensaje}
            />
            {objWait()}
            <Card
                elevation={12}
                sx={{
                    borderRadius: 2,
                    width: "420px",
                    maxWidth: "90%",
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                    border: '1px solid rgba(212, 175, 55, 0.3)'
                }}
            >
                {/* Header Corporate Blue */}
                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    py: 4,
                    px: 4,
                    borderBottom: '3px solid #d4af37'
                }}>
                    <Typography
                        variant='h4'
                        sx={{
                            textAlign: 'center',
                            color: '#ffffff',
                            fontWeight: 700,
                            letterSpacing: 2,
                            textTransform: 'uppercase'
                        }}
                    >
                        Bienvenido
                    </Typography>
                    <Typography
                        variant='body2'
                        sx={{
                            textAlign: 'center',
                            color: '#d4af37',
                            mt: 1,
                            fontWeight: 500,
                            letterSpacing: 1
                        }}
                    >
                        Sistema de Inversiones
                    </Typography>
                </Box>

                {/* Formulario */}
                <Box sx={{ p: 4, backgroundColor: '#fafbfc' }}>
                    <Stack spacing={3}>
                        <Box>
                            <InputLabel
                                htmlFor="usuario"
                                sx={{ mb: 1, color: '#1e3a5f', fontWeight: 600, fontSize: '0.875rem' }}
                            >
                                Usuario
                            </InputLabel>
                            <OutlinedInput
                                id="usuario"
                                type="text"
                                autoComplete='off'
                                value={usuario}
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                name="usuario"
                                placeholder="Ingrese su usuario"
                                fullWidth
                                sx={{
                                    borderRadius: 1,
                                    backgroundColor: '#ffffff',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#cbd5e0'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#2c5282'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#d4af37',
                                        borderWidth: 2
                                    }
                                }}
                            />
                        </Box>
                        <Box>
                            <InputLabel
                                htmlFor="password"
                                sx={{ mb: 1, color: '#1e3a5f', fontWeight: 600, fontSize: '0.875rem' }}
                            >
                                Contrasena
                            </InputLabel>
                            <OutlinedInput
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                name="password"
                                placeholder="Ingrese su contrasena"
                                fullWidth
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                            sx={{ color: '#1e3a5f' }}
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                sx={{
                                    borderRadius: 1,
                                    backgroundColor: '#ffffff',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#cbd5e0'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#2c5282'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#d4af37',
                                        borderWidth: 2
                                    }
                                }}
                            />
                        </Box>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={clickLogin}
                            sx={{
                                background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)',
                                    boxShadow: '0 4px 15px rgba(44, 82, 130, 0.4)'
                                },
                                py: 1.5,
                                fontSize: '1rem',
                                fontWeight: 700,
                                borderRadius: 1,
                                textTransform: 'uppercase',
                                letterSpacing: 2,
                                mt: 2,
                                boxShadow: '0 2px 10px rgba(30, 58, 95, 0.3)',
                                border: '1px solid rgba(212, 175, 55, 0.5)'
                            }}
                        >
                            Iniciar Sesion
                        </Button>
                    </Stack>
                </Box>

                {/* Footer con acento dorado */}
                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    py: 1.5,
                    borderTop: '2px solid #d4af37'
                }}>
                    <Typography
                        variant='caption'
                        sx={{
                            textAlign: 'center',
                            display: 'block',
                            color: '#d4af37',
                            fontWeight: 500,
                            letterSpacing: 1
                        }}
                    >
                        Acceso Seguro
                    </Typography>
                </Box>
            </Card>
        </Box>
    )
}